export default {
  0: {
    text: "В ожидании средств",
    icon: "el-icon-circle-plus",
    color: "primary",
  },
  1: {
    text: "В обработке",
    icon: "el-icon-warning",
    color: "warning",
  },
  2: {
    text: "Подтверждена",
    icon: "el-icon-success",
    color: "success",
  },
  3: {
    text: "Отклонена",
    icon: "el-icon-error",
    color: "danger",
  },
  4: {
    text: "Отменена",
    icon: "el-icon-error",
    color: "danger",
  },
  5: {
    text: "В ожидании фото для верификации",
    icon: "el-icon-warning",
    color: "warning",
  },
  6: {
    text: "В ожидании верификации",
    icon: "el-icon-warning",
    color: "warning",
  },
  default: {
    text: "Неизвестный статус",
    icon: "el-icon-warning",
    color: "info",
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/ApiUsers/Stats/statuses.js